import { useEffect } from 'react';

import { setInitialLandingURL } from '@pharmaplan/common';

import { useAppDispatch } from './useAppDispatch';
import { allowedPaths } from '../helpers/Constants';
import useHandleLandingUrls from './useHandleLandingUrls';

const useLoggedOutUrls = () => {
  const dispatch = useAppDispatch();
  useHandleLandingUrls();

  const url = new URL(globalThis.location.href);
  const { pathname } = url ?? {};

  useEffect(() => {
    if (allowedPaths.has(pathname)) {
      dispatch(setInitialLandingURL(url.href));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
};

export default useLoggedOutUrls;
